<template>
	<div class="card">
		<div class="card-title">3. 聊天页面专属配置</div>

		<div class="row">
			<div class="label">头部标题</div>
			<input v-model="value.headerTitle" style="width:280px" :disabled="vimSave" />
		</div>

		<div class="row">
			<div class="label">头部背景色</div>
			<input v-model="value.headerBg" style="width:120px" disabled />
			<input type="color" v-model="value.headerBg" class="native-color-picker" :disabled="vimSave" />
			<!-- <div class="color-preview" :style="{background:value.headerBg}"></div> -->
		</div>

		<div class="row">
			<div class="label">页面背景色</div>
			<input v-model="value.pageBg" style="width:120px" disabled />
			<input type="color" v-model="value.pageBg" class="native-color-picker" :disabled="vimSave" />
			<!-- <div class="color-preview" :style="{background:value.pageBg}"></div> -->
		</div>
		<div class="row">
			<div class="label">默认AI引导</div>
			<input v-model="value.aiContentText" style="width:280px" :disabled="vimSave" />
		</div>
		<!-- 顶部左侧图标 -->
		<div class="row">
			<div class="label">顶部左侧图标</div>
			<img v-if="isImage(iconUrlMap.topIcon1)" :src="iconUrlMap.topIcon1" class="icon-preview" />
			<span v-else class="emoji-preview">{{ iconUrlMap.topIcon1 }}</span>
			<label class="upload-btn">上传<input type="file" hidden accept="image/*" @change="select('topIcon1', $event)"
					:disabled="vimSave" /></label>
			<button @click="reset('topIcon1')" :disabled="vimSave" class="reset-btn">重置</button>
		</div>

		<!-- 顶部右侧图标 -->
		<div class="row">
			<div class="label">顶部右侧图标</div>
			<img v-if="isImage(iconUrlMap.topIcon2)" :src="iconUrlMap.topIcon2" class="icon-preview">
			<span v-else class="emoji-preview">{{ iconUrlMap.topIcon2 }}</span>
			<label class="upload-btn">上传<input type="file" hidden accept="image/*" @change="select('topIcon2', $event)"
					:disabled="vimSave" /></label>
			<button @click="reset('topIcon2')" class="reset-btn" :disabled="vimSave">重置</button>
		</div>

		<!-- 学生头像 -->
		<div class="row">
			<div class="label">学生头像</div>
			<img v-if="isImage(iconUrlMap.avatarStu)" :src="iconUrlMap.avatarStu" class="icon-preview">
			<span v-else class="emoji-preview">{{ iconUrlMap.avatarStu }}</span>
			<label class="upload-btn">上传<input type="file" hidden accept="image/*" :disabled="vimSave"
					@change="select('avatarStu', $event)" /></label>
			<button @click="reset('avatarStu')" :disabled="vimSave" class="reset-btn">重置</button>
		</div>

		<!-- AI头像 -->
		<div class="row">
			<div class="label">AI头像</div>
			<img v-if="isImage(iconUrlMap.avatarAi)" :src="iconUrlMap.avatarAi" class="icon-preview">
			<span v-else class="emoji-preview">{{ iconUrlMap.avatarAi }}</span>
			<label class="upload-btn">上传<input type="file" hidden accept="image/*" :disabled="vimSave"
					@change="select('avatarAi', $event)" /></label>
			<button @click="reset('avatarAi')" class="reset-btn" :disabled="vimSave">重置</button>
		</div>

		<!-- 教师头像 -->
		<div class="row">
			<div class="label">教师头像</div>
			<img v-if="isImage(iconUrlMap.avatarTea)" :src="iconUrlMap.avatarTea" class="icon-preview">
			<span v-else class="emoji-preview">{{ iconUrlMap.avatarTea }}</span>
			<label class="upload-btn">上传<input type="file" hidden accept="image/*" :disabled="vimSave"
					@change="select('avatarTea', $event)" /></label>
			<button @click="reset('avatarTea')" class="reset-btn" :disabled="vimSave">重置</button>
		</div>

		<div class="row">
			<div class="label">自己气泡色</div>
			<input v-model="value.bubbleSelf" style="width:120px" disabled />
			<input type="color" v-model="value.bubbleSelf" class="native-color-picker" :disabled="vimSave" />
		</div>

		<div class="row">
			<div class="label">对方气泡色</div>
			<input v-model="value.bubbleOther" style="width:120px" disabled />
			<input type="color" v-model="value.bubbleOther" class="native-color-picker" :disabled="vimSave" />
		</div>

		<div class="row">
			<div class="label">AI模型配置</div>
			<div style="display: flex; gap: 20px; align-items: center;">
				<el-select v-model="value.modelId" @change="forModelId" filterable clearable placeholder="选择聊天模型"
					style="width: 160px;" :disabled="vimSave">
					<el-option v-for="m in modelList" :key="m.id" :label="m.name" :value="m.id" />
				</el-select>
				<el-select v-model="value.keyId" :disabled="!value.modelId||vimSave" filterable clearable
					placeholder="选择聊天密钥" style="width: 160px;">
					<el-option v-for="k in keyList" :key="k.id" :label="k.keyName" :value="k.id" />
				</el-select>
			</div>
		</div>
		<div style="display: flex;gap:12px;">
		  <label v-for="ct in chateTypeList" :key="ct.value">
		    <input
		      :checked="(value.chatFily || []).includes(ct.value)"
		      @change="handleChatTypeChange(ct.value, $event)"
		      type="checkbox"
		      :disabled="vimSave"
		    />
		    {{ ct.label }}
		  </label>
		
		</div>
		<span style="color: coral;font-size: 12px;">请根据智能体/模型的功能勾选</span>
	</div>
</template>

<script>
	import {
		fileToBase64
	} from '@/js/img.js'
	// import {} from 
	// 定义默认emoji
	const defaultEmoji = {
		topIcon1: '🌙',
		topIcon2: '🍅',
		avatarStu: '🎓',
		avatarAi: '🍅',
		avatarTea: '📝'
	}
	export default {
		props: {
			value: {
				type: Object,
				default: () => ({})
			},
			modelList: {
				type: Array,
				default: () => []
			},
			vimSave: {
				type: Boolean,
				default: false,
			}
			// keyList: { type: Array, default: () => [] },
		},
		data() {
			return {
				iconUrlMap: {},
				keyList: [],
				chateTypeList: [{
						value: 'text',
						label: '对话'
					},
					{
						value: 'img',
						label: '图片'
					},
					// {
					// 	value: 'file',
					// 	label: '文件'
					// }
				],
			}
		},
		watch: {
			value: {
				handler() {
					this.resolveAllIconUrl()
				},
				immediate: true,
				deep: true,

			},
			vimSave: {
				type: Boolean,
				default: false,
			}
		},
		created() {
			this.tomodelList()
		},
		methods: {
			handleChatTypeChange(val, e) {
			  // 拷贝父组件传过来的对象，不能直接改prop
			  const newValue = { ...this.value }
			  // 兜底数组，防止 chatFily 为 undefined / null
			  let arr = [...(newValue.chatFily || [])]
			  if (e.target.checked) {
			    if (!arr.includes(val)) {
			      arr.push(val)
			    }
			  } else {
			    arr = arr.filter(item => item !== val)
			  }
			  newValue.chatFily = arr
			  // 触发 input 事件通知父组件更新 value
			  this.$emit('input', newValue)
			},
			async tomodelList() {
				console.log('value', this.value.modelId)
				try {
					let providerCode = this.modelList.filter(v => v.id == this.value.modelId)[0].aiTypeCode || ''
					const res = await this.API.get(this.API.admin.getModelKeySimple, {
						pageNum: 1,
						pageSize: 100,
						providerCode: providerCode,
						modelTypeId: null
					})
					this.keyList = res.data.data || []
				} catch (error) {
					this.keyList = []
				}
			},
			async forModelId(val) {

				this.value.keyId = ''
				try {
					let providerCode = this.modelList.filter(v => v.id == val)[0].aiTypeCode || ''
					const res = await this.API.get(this.API.admin.getModelKeySimple, {
						pageNum: 1,
						pageSize: 100,
						providerCode: providerCode,
						modelTypeId: null
					})
					this.keyList = res.data.data || []
				} catch (error) {
					this.keyList = []
				}
			},
			isImage(val) {
				return typeof val === 'string' && (val.startsWith('data:') || val.startsWith('http'))
			},
			// 批量解析所有图标
			async resolveAllIconUrl() {
				const map = {}
				map.topIcon1 = await this.getFinalIconUrl('topIcon1', this.value.topIcon1)
				map.topIcon2 = await this.getFinalIconUrl('topIcon2', this.value.topIcon2)
				map.avatarStu = await this.getFinalIconUrl('avatarStu', this.value.avatarStu)
				map.avatarAi = await this.getFinalIconUrl('avatarAi', this.value.avatarAi)
				map.avatarTea = await this.getFinalIconUrl('avatarTea', this.value.avatarTea)
				this.iconUrlMap = map
			},

			// 统一处理：空值取默认emoji，https走OSS，其余直接返回
			async getFinalIconUrl(field, iconStr) {
				// 为空则返回默认emoji
				if (!iconStr) {
					return defaultEmoji[field]
				}
				// https 链接解析OSS
				if (iconStr.startsWith('https:')) {
					return await this.$oss.getUrl(iconStr)
				}
				// base64 / 已有地址 / 手动设置的emoji 直接返回
				return iconStr
			},

			// 上传图片
			async select(key, e) {
				const file = e.target.files[0]
				if (!file) return
				const base64 = await fileToBase64(file)
				const newValue = {
					...this.value
				}
				newValue[key] = base64
				this.$emit('input', newValue)
				e.target.value = ''
			},

			// 重置：恢复为默认emoji
			reset(key) {
				const newValue = {
					...this.value
				}
				newValue[key] = defaultEmoji[key]
				this.$emit('input', newValue)
			},
		}
	}
</script>

<style scoped>
	.card {
		background: #fff;
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 16px;
		box-shadow: 0 2px 8px #00000010;
	}

	.card-title {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 12px;
		color: #333;
	}

	.row {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;
	}

	.label {
		width: 110px;
		font-size: 14px;
		color: #666;
	}

	input {
		padding: 6px 10px;
		border: 1px solid #ddd;
		border-radius: 6px;
		font-size: 14px;
	}

	.color-preview {
		width: 20px;
		height: 20px;
		border-radius: 4px;
		border: 1px solid #ddd;
	}

	.icon-preview {
		width: 28px;
		height: 28px;
		object-fit: contain;
		border-radius: 4px;
	}

	.emoji-preview {
		font-size: 20px;
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-btn {
		padding: 4px 10px;
		background: #e8f3ff;
		color: #2b85e4;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
		border: 1px solid #b3d8ff;
	}

	.reset-btn {
		padding: 4px 8px;
		background: #f5f5f5;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
	}

	.native-color-picker {
		width: 30px;
		height: 30px;
		border: none;
		background: none;
		cursor: pointer;
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch-wrapper {
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch {
		border-radius: 4px;
		border: 1px solid #ddd;
	}
</style>